module.exports = __webpack_public_path__ + "static/media/ts15tj538.a362ea49.png";